import { Component, ViewModel, View, ObservableArray } from "binder";
import { ITemplateSelector } from "../templateSelector";
import { getAsBoolean } from "../utilities";
import  { ComboBoxView } from "./comboBox-view"

export class ComboBoxViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.selectedindex=-1;
    }
    GetDefaultView(): View <ViewModel> {
        return new ComboBoxView();
    }
    public getTypeId(): string {
        return "VM-0ECE0A99-7FD1-417C-9E35-4336B354D01B"
    }

    public set items(v: ObservableArray<ViewModel>) { this._items = v; } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set selected(v: ViewModel) { this._selected = v; } public get selected(): ViewModel { return this._selected;} private _selected: ViewModel;
    public set selectedvalue(v: string) { this._selectedvalue = v; } public get selectedvalue(): string { return this._selectedvalue;} private _selectedvalue: string;
    public set selectedindex(v: number) { this._selectedindex = v; } public get selectedindex(): number { return this._selectedindex;} private _selectedindex: number;
    public set itemtemplateselector(v: ITemplateSelector) { this._itemtemplateselector = v; } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { this._templateselectorfunction = v; } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = getAsBoolean(v); } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;
    
}
